// File: frontend/src/config/subnavIcons.js
// Date: 2026-10-17
// Назначение: системные линейные иконки (lucide-react) для полос подразделов (SectionSubnav).
// Заменяет эмодзи-иконки в полосах подразделов в рамках единой дизайн-системы (Фаза I).

import {
    Home,
    Briefcase,
    Users,
    Mail,
    Calendar,
    CheckSquare,
    User,
    Scale,
    Mic,
    Bot,
    Cpu,
    Star,
    Globe,
    BarChart2,
    CreditCard,
    FileText,
    Sparkles,
    ClipboardList,
    Building,
    History,
    Inbox,
    Newspaper,
} from 'lucide-react';

export const SUBNAV_ICONS = {
    dashboard: Home,
    cases: Briefcase,
    leads: Users,
    email_inbox: Mail,
    calendar: Calendar,
    tasks: CheckSquare,
    client_portal: User,
    ai_paralegal: Scale,
    voice_ai: Mic,
    ai_staff: Bot,
    brain_center: Cpu,
    reputation: Star,
    organic_seo: Globe,
    seo_analytics: BarChart2,
    blog: Newspaper,
    billing: CreditCard,
    doc_generator: FileText,
    magic_deploy: Sparkles,
    users: Users,
    audit_log: ClipboardList,
    company_profile: Building,
    profile: User,
    history: History,
    inbox: Inbox,
    ai_ops: Cpu,
};

export default SUBNAV_ICONS;
